import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { SecurityFeatureUtility } from '../services/security-feature.utility';
import { Features } from '../enums/features.enum';

interface FeatureAccessGuardData {
    feature: Features,
    allowOnlyIfManage: boolean,
    redirectToAccessDenied: boolean
}

export const getFeatureAccessGuardData = (feature: Features, redirectToAccessDenied: boolean = true, allowOnlyIfManage: boolean = false) => {
    return {
        featureGuardData: {
            feature,
            allowOnlyIfManage,
            redirectToAccessDenied
        } as FeatureAccessGuardData
    }
};

@Injectable({ providedIn: 'root' })
export class FeatureAccessGuard implements CanActivate {

    constructor(
        private securityFeatureUtility: SecurityFeatureUtility,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const featureData = route.data['featureGuardData'] as FeatureAccessGuardData | undefined;

        if (!featureData || !featureData.feature) return true;

        const redirectToAccessDeniedPage = () => this.router.createUrlTree(['/access-denied']);

        const { canView, canManage } = this.securityFeatureUtility.getPermissions(featureData.feature, false);

        if (featureData.allowOnlyIfManage) {
            if (canManage) return true;
            if (featureData.redirectToAccessDenied) return redirectToAccessDeniedPage();
        }

        if (canView) return true;
        if (featureData.redirectToAccessDenied) return redirectToAccessDeniedPage();
        return true;
    }
}
